module.exports = __webpack_public_path__ + "img/首页-楼盘库开放平台@2x.1ee785a7.png";